import { useCallback, useContext } from "react";

import { ApplicationContext } from "../context/GlobalState";
import { setMobileMenuOpen } from "../context/actions";

/**
 * Manage the fullscreen mobile menu state.
 * Translation: Manage the fullscreen mobile menu state.
 *
 * @returns {Object} Menu state helpers.
 */
const useMobileMenu = () => {
  const [state, dispatch] = useContext(ApplicationContext);

  /**
   * Open the mobile menu.
   * Translation: Open the mobile menu.
   */
  const openMenu = useCallback(() => {
    dispatch(setMobileMenuOpen(true));
  }, [dispatch]);

  /**
   * Close the mobile menu.
   * Translation: Close the mobile menu.
   */
  const closeMenu = useCallback(() => {
    dispatch(setMobileMenuOpen(false));
  }, [dispatch]);

  /**
   * Toggle the mobile menu state.
   * Translation: Toggle the mobile menu state.
   */
  const toggleMenu = useCallback(() => {
    dispatch(setMobileMenuOpen(!state.isMobileMenuOpen));
  }, [dispatch, state.isMobileMenuOpen]);

  return {
    isMobileMenuOpen: state.isMobileMenuOpen,
    openMenu,
    closeMenu,
    toggleMenu,
  };
};

export default useMobileMenu;
